<template>
  <pt-adult-stock-list class="pt-adult-stock-list__page"></pt-adult-stock-list>
</template>

<script>
import PtAdultStockList from 'cps/adult-stocks-manage/pt-adult-stock-list/withData'
export default {
  name: 'pt-adult-stock-list__view',
  components: {
    'pt-adult-stock-list': PtAdultStockList
  }
}
</script>
